<template>
  <el-dialog
    v-bind="$attrs"
    :visible="visible"
    :show-close="false"
    :fullscreen="fullscreen"
    @open="$emit('open')"
    :append-to-body="true"
    :modal="modal"
    :before-close="beforeClose"
    top="0"
    :width="width"
    class="base-dialog"
    :custom-class="classList"
    :modal-fade="false"
  >
    <template slot="title">
      <div v-if="$slots.header" class="header">
        <slot name="header"></slot>
        <span v-if="showClose" class="icon-close" @click="beforeClose">
          <svg-icon icon-class="close"></svg-icon>
        </span>
      </div>
    </template>
    <slot></slot>
    <template slot="footer">
      <div v-if="$slots.footer" class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "old-dialog",
  props: {
    loading: Boolean,
    visible: Boolean,
    modal: {
      type: Boolean,
      default: true
    },
    borderRadius: {
      type: String,
      default: "normal" // none small normal medium
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    showClose: Boolean,
    width: {
      type: String,
      default: "560px"
    }
  },
  data() {
    return {
      testVisible: false
    }
  },
  computed: {
    classList() {
      if (this.fullscreen) return "border-radius-none is-fullscreen"
      if (this.borderRadius) return "border-radius-" + this.borderRadius
      return ""
      // let classList = ""
      // if (!this.fullscreen && this.borderRadius) {
      //   classList = classList + " border-radius-" + this.borderRadius
      // }
      // if (this.fullscreen) classList = classList + "border-radius-none is-fullscreen"
      // return classList
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) this.$emit("closed")
    }
  },
  methods: {
    // Dialog 关闭前的回调
    beforeClose() {
      this.$emit("update:visible", false)
      this.$emit("closed")
    },
    // 保存表单
    save() {
      // console.log("保存")
    }
  }
}
</script>

<style lang="scss" scoped>
.base-dialog {
  min-width: 560px;
  font-size: 13px;
  display: flex;
  display: -webkit-box;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  animation: none !important;
  ::v-deep .el-dialog {
    position: relative;
    margin: 0;
    display: flex;
    max-height: calc(100% - 50px);
    flex-direction: column;
    &.is-fullscreen {
      max-height: 100%;
    }

    &.border-radius-none {
      border-radius: 0;
    }
    &.border-radius-small {
      border-radius: 0;
    }
    &.border-radius-normal {
      border-radius: 0;
    }
    &.border-radius-medium {
      border-radius: 0;
    }

    .el-dialog__header {
      padding: 0;
    }

    .header {
      display: flex;
      align-items: center;
      padding: 0 24px;
      font-size: $font-size-title-first;
      height: 52px;
      border-bottom: 2px solid #f5f5f5;
      .icon-close {
        cursor: pointer;
        margin-left: auto;
      }
    }

    .el-dialog__body {
      min-height: 100px;
      overflow: auto;
      padding: 0 22px;
      color: #9e9e9e;
      &::-webkit-scrollbar {
        display: none;
      }
      .el-loading-spinner {
        margin-top: 0;
      }
    }

    .el-dialog__footer {
      padding: 0;
    }

    .footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;
      height: 52px;
      border-top: 2px solid #f5f5f5;
    }
  }
}
</style>
